import gql from 'graphql-tag';

export default gql`
  fragment customDashboardFragment on CustomDashboard {
    _id
    name
    icon
    dashboardId
    filterType
    embedUrl
    groupId
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/customDashboardFragment.js